import React from 'react';
import './AppMessage.css';

function AppMessage(props) {
    const handleBackClick = (e) => {
        e.preventDefault();
        window.location.href = "/#";
    };

    return (
        <div className="app-message-compact">
            <div className="app-message-content">
                <h3 className="app-message-title">{props.message || "Coming Soon"}</h3>
                <a href="/#" className="app-message-btn" onClick={handleBackClick}>
                    Back To Dashboard
                </a>
            </div>
        </div>
    );
}

export default AppMessage;